<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "InventoryReports",
    data() {
        return {
            msg: 'Inventory Reports Here',
        }
    },
}
</script>

<style scoped>

</style>
